<template>
  <v-dialog v-model="dialog" max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline"
          >Update {{ dataForm.name || dataForm.file_name || "" }}</span
        >
      </v-card-title>

      <v-card-text>
        <div class="text-subtitle-2 mb-4">
          Provide Data Source allow agent to automatically answer customers
          questions with accurate and relevant information
        </div>

        <v-container>
          <v-form ref="form">
            <v-text-field
              v-model="dataForm.name"
              label="Name"
              placeholder="Give data source name or title"
            ></v-text-field>

            <v-textarea
              v-model="dataForm.full_text"
              label="Text"
              placeholder="Enter text here"
              rows="20"
            ></v-textarea>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">Save changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UpdateKnowledge",

  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    botId: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
      dataForm: {
        file_name: "",
        full_text: "",
        name: "",
      },
    };
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.fetchDataSource();
      },
    },
    dialog(val) {
      this.$emit("close", val);
    },
    showDialog: {
      immediate: true,
      handler(val) {
        this.dialog = val;
        console.log("showDialog", val);
        this.$emit("close", val);
      },
    },
  },

  methods: {
    async fetchDataSource() {
      try {
        if (!this.data.uuid) return;
        const response = await this.$store.dispatch("llm/knowledge/getOne", {
          botID: this.botId,
          id: this.data.uuid,
        });
        this.dataForm = response;
      } catch (error) {
        console.error("Error fetching data source:", error);
      }
    },

    async save() {
      await this.$store.dispatch("llm/knowledge/update", {
        botID: this.botId,
        id: this.data.uuid,
        data: { ...this.dataForm, text: this.dataForm.full_text },
      });

      this.$emit("submitted");
      this.dialog = false;
      this.$store.dispatch("setSnackbar", {
        text: `Data source has been updated successfully`,
        color: "success",
        status: true,
      });
    },
  },
};
</script>

<style scoped>
.v-dialog {
  margin: 0;
}
</style>
